import React from 'react';
interface Props {
  status: 'active' | 'inactive';
}
export const StatusBadge = ({
  status
}: Props) => {
  const styles = {
    active: 'bg-status-success/10 border-status-success/30 text-status-success',
    inactive: 'bg-surface border-surface-border text-gray-400'
  };
  return <span className={`
        inline-flex items-center gap-1.5 px-2.5 py-1
        border rounded-none text-xs font-mono uppercase tracking-wider
        ${styles[status]}
      `} data-id="element-961">
      <span className={`
          w-1.5 h-1.5 rounded-none
          ${status === 'active' ? 'bg-status-success animate-pulse' : 'bg-gray-400'}
        `} data-id="element-962" />
      {status === 'active' ? 'Active' : 'Inactive'}
    </span>;
};